import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { PropsWithChildren, ReactElement } from "react";
import { useIntl } from "react-intl";

import styles from "@components/SectionWithBanner.module.css";
import Heading2 from "@components/typography/Heading2";

type Props = PropsWithChildren<{
  renderControls?: () => ReactElement;
  titleKey: string;
}>;

const SectionWithBanner = ({ children, renderControls, titleKey }: Props) => {
  const intl = useIntl();

  return (
    <>
      <div className={styles.sectionBanner}>
        <IonGrid className={"ion-no-padding " + styles.header}>
          <IonRow className="ion-no-padding">
            <IonCol className={"ion-no-padding " + styles.title}>
              <Heading2>{intl.formatMessage({ id: titleKey })}</Heading2>
            </IonCol>
            {renderControls && (
              <IonCol className="align-right" size="auto">
                {renderControls()}
              </IonCol>
            )}
          </IonRow>
        </IonGrid>
      </div>
      <div className={styles.children}>{children}</div>
    </>
  );
};

export default SectionWithBanner;
